'use client'

import axios from 'axios'

export const BASE_URL = process.env.NEXT_PUBLIC_API_HOST || 'https://api.extra.app/v1'

export const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'User-Agent': `${process.env.NEXT_PUBLIC_APP_NAME}-${process.env.NEXT_PUBLIC_APP_ENV}/${process.env.NEXT_PUBLIC_VERSION}`
  }
})

api.interceptors.request.use(
  (config) => {

    const params = new URLSearchParams(location.search)

    const ivrToken = params.get('auth')
    const portalToken = params.get('portal')
    const conversationId = params.get('cid')

    if (portalToken) {
      config.headers.authorization = `CustomerPortal ${portalToken}`
      config.headers['x-conversation-id'] = `${conversationId}`
    } else if (ivrToken)
      config.headers.authorization = `IVR ${ivrToken}`
    else
      throw new Error('Missing auth URL param')

    return config
  },
  (error) => Promise.reject(error)
)

export async function submitReport(url, { arg }) {
  const { transactions } = arg

  if (!url) {
    throw new Error('Missing URL')
  }

  if (!transactions?.length) {
    throw new Error('Missing transactions')
  }

  if (!transactions.every(({ id, reason, noticeDate, additionalDetails }) => reason && id && noticeDate?.length && (additionalDetails && Object.entries(additionalDetails).every(([, value]) => value !== null)))) {
    throw new Error('Missing transaction id or reason')
  }

  // Create a FormData object
  const formData = new FormData()

  transactions.forEach((transaction) => {
    const { id, reason, noticeDate, additionalDetails } = transaction

    formData.append(`transactions[${id}][id]`, id)
    formData.append(`transactions[${id}][reason]`, reason)
    formData.append(`transactions[${id}][noticeDate]`, noticeDate)

    // Check additionalDetails for file uploads
    if (additionalDetails) {
      Object.entries(additionalDetails).forEach(([key, userInput]: [key: string, userInput: { value: string | File[], type: string, question: string }]) => {
        debugger
        if (userInput.type === 'fileUpload' && Array.isArray(userInput.value)) {
          // It's a file upload
          userInput.value.forEach((file, fileIndex) => {
            formData.append(`[${id}].[${key}].[${fileIndex}]`, file)
          })
        } else {
          formData.append(`transactions[${id}][additionalDetails]`, JSON.stringify(userInput))
        }
      })
    }
  })

  return api.post(`/self-serve/customer-portal${url}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
